import { atom } from 'recoil';

export const searchTermAtom = atom({
  key: 'searchTermAtom',
  default: {
    term: '',
    categoryId: null,
    loading: false,    
  },
});